import { useQuery } from '@tanstack/react-query';
import { IProductCategory } from 'src/interfaces';
import { queryKeys, requestCCApi } from 'src/utils';

export const useGetProductCategory = (
  productCategoryId: string,
  enabled = true,
) => {
  return useQuery({
    queryKey: queryKeys.productCategories.details(productCategoryId),
    queryFn: () => fetchProductCategory(productCategoryId),
    staleTime: Infinity,
    enabled,
  });
};

const fetchProductCategory = async (productCategoryId: string) => {
  const url = `/productCategories/${productCategoryId}`;

  const response = await requestCCApi({ url });

  return response.data as IProductCategory;
};
